import { GET_RC_TICKET_LIST, STATUS_UPDATE } from "./type";

const initalState = {
    rcTransferListing: [],
    updateRcStatus: []
};

const rcTransferReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_RC_TICKET_LIST:
            return {
                ...state,
                rcTransferListing: payload
            };
        case STATUS_UPDATE:
            return {
                ...state,
                updateRcStatus: payload
            };
        default:
            return {
                ...state,
            };
    }
};

export default rcTransferReducer;
